const elements = {
    postcodes: document.body.querySelectorAll('.js-postcode'),
  };
  function applyPostcodeFormat(postcode) {
    const postValue = postcode.target.value.replace(' ', '');
    if (postValue.length > 4) {
      const lastThree = postValue.substr(postValue.length - 3);
      const firstCharacters = postValue.substr(0, postValue.length - 3);
      postcode.target.value = `${firstCharacters} ${lastThree}`;
    }
  }
  function init() {
    if (elements.postcodes.length) {
      elements.postcodes.forEach(postcode => postcode.addEventListener('keyup', applyPostcodeFormat));
    }
  }
  export default init;




// WEBPACK FOOTER //
// ./src/components/components/reportAProblem/postcode-lookup/postcode.js